module.exports = __webpack_public_path__ + "static/media/bpmeasurex-1.5d0f99ed.jpg";